import { render } from "./App.vue?vue&type=template&id=f55ed4a6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f55ed4a6&lang=scss"

import exportComponent from "/home/admin/swarm-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__